import { FC } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface OverlayLoadingProps {
    open: boolean;
  //  children?: React.ReactNode;
}

const OverlayLoading: FC<OverlayLoadingProps> = ({ open }) => {

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  );
}

export default OverlayLoading;